import { Checkbox } from "@mui/material";
import { iDataUserSuscription } from "../../../interfaces/SuperAdmin/Pages/iDataUserSuscription";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";
import { formatFechaWithHour } from "../../../utils/dateFunctions";

interface Props {
  usuario: iDataUserSuscription;
  i: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

export const ProfileRowUserSuscription: React.FC<Props> = ({
  usuario,
  i,
  isSelected,
  handleSelect,
}) => {
  const {
    nombres,
    apellidos,
    fecha_asignacion,
    creditos_gastados,
    estado,
    email,
  } = usuario;
 

  return (
    <StyledTableRow>
      <StyledTableCell>
        <Checkbox
          color="primary"
          checked={isSelected}
          onChange={() => handleSelect(usuario.id_usuario)}
        />
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 2, textAlign: "center" }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {nombres}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {apellidos}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {email}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {formatFechaWithHour(fecha_asignacion)}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {creditos_gastados}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4, textAlign: "center" }}>
        {estado}
      </StyledTableCell>
    </StyledTableRow>
  );
};
